import { LIST_LIMIT_REACHED_CODE } from '@lib/api/productLists/errorCodes';
import { FetchError } from '@lib/types/api/FetchError';

export class ListApiError extends Error {
  public status: number;
  public code?: string;

  constructor(status: number, message?: string, code?: string) {
    super(message);
    this.name = 'ListApiError';
    this.status = status;
    this.code = code;
  }
}

export type CreateListErrorType = 'network' | 'limit';

export const isListLimitError = (error: unknown): boolean =>
  (error instanceof ListApiError || error instanceof FetchError) &&
  error.code === LIST_LIMIT_REACHED_CODE;

export const classifyCreateListError = (error: unknown): CreateListErrorType =>
  isListLimitError(error) ? 'limit' : 'network';
